import { Category, CategoryReq } from "../../../types/productType";
import { beautyLevelThree } from "../levelThree/beautyLevelThree";
import { electronicsLevelThree } from "../levelThree/electronicLevelThree";
import { furnitureLevelThree } from "../levelThree/funitureLevelThree";
import { menLevelThree } from "../levelThree/menLevelThree";
import { womenLevelThree } from "../levelThree/womenLevelThree";
import { beautyLevelTwo } from "../levelTwo/beautyLevelTwo";
import { electronicsLevelTwo } from "../levelTwo/electronicsLevelTwo";
import { furnitureLevelTwo } from "../levelTwo/funitureLevelTwo";
import { menLevelTwo } from "../levelTwo/menLevelTwo";
import { womenLevelTwo } from "../levelTwo/womenLevelTwo";
import { mainCategory } from "../mainCategory";

export const categoryTwo: { [key: string]: any[] } = {
    men: menLevelTwo,
    women: womenLevelTwo,
    electronics: electronicsLevelTwo,
    home_furniture: furnitureLevelTwo,
    beauty: beautyLevelTwo,
  };
  export const categoryThree: { [key: string]: any[] } = {
    men: menLevelThree, 
    women: womenLevelThree,
    electronics: electronicsLevelThree,
    home_furniture: furnitureLevelThree,
    beauty: beautyLevelThree,
  };
  export const allCategories: CategoryReq[] = [
    ...mainCategory,
    ...Object.values(categoryTwo).flat(),
    ...Object.values(categoryThree).flat(),
  ];
  export const categoryById = new Map<string, CategoryReq>(
    allCategories.map((c) => [c.categoryId, c])
  );

  export const getCategoryLevelsFromId = (categoryId: string) => {
    // sẽ lưu tạm chuỗi category từ dưới lên trên
    const tempChain: CategoryReq[] = [];
  
    // bắt đầu từ category có id truyền vào
    let currentCategory: CategoryReq | null =
      categoryById.get(categoryId) || null;
  
    // nếu không tìm thấy -> trả về rỗng
    if (!currentCategory) {
      return {
        level1: undefined,
        level2: undefined,
        level3: undefined,
        chain: [] as CategoryReq[],
      };
    }
  
    // đi ngược từ con lên cha cho đến khi hết parent
    while (currentCategory) {
      tempChain.push(currentCategory); // thêm vào chuỗi
  
      // nếu không còn parent -> đã tới level 1
      if (!currentCategory.parentCategoryId) {
        break;
      }
  
      // cập nhật currentCategory thành category cha
      currentCategory =
        categoryById.get(currentCategory.parentCategoryId) || null;
    }
  
    // tempChain hiện là [level3, level2, level1] -> đảo lại
    const chain = tempChain.reverse(); // [level1, level2, level3]
  
    const level1 = chain[0];
    const level2 = chain[1];
    const level3 = chain[2];
  
    return { level1, level2, level3, chain };
  };
  